import { gql } from 'graphql-request';
import { Sample } from 'src/shared/types';

export const sampleMetricsTableQuery = gql`
    query getSamples($projectId: String!, $samples: sampleFilter) {
        sampleMetricsTableData: project(projectId: $projectId, samples: $samples) {
            samples {
                sampleId
                sampleCollectedDatetime
                metrics
                covariates
                location {
                    coordinates
                }
            }
        }
    }
`;

type SampleMetricsTableData = {
    samples: Pick<Sample, 'sampleId' | 'sampleCollectedDatetime' | 'metrics' | 'covariates' | 'location'>[];
};

export type SampleMetricsTableQueryResult = {
    sampleMetricsTableData: SampleMetricsTableData;
};
